import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ExcelExportService, FilterService, FilterSettingsModel, GridComponent, PdfExportService, QueryCellInfoEventArgs, ToolbarItems, ToolbarService, VirtualScrollService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent, Tooltip, TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { DataUtil } from '@syncfusion/ej2-data';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { IServerSettings } from '../../../shared/models/index';
import { FileUploadService } from '../../../shared/services/fileupload.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { StorageManagerService } from '../../../shared/services/storage-manager.service';
import { NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

class LastCallTime {
  fileMetadataGuid: string;
  callTime: any;

  constructor (fileMetadataGuid: string, callTime: any) {
    this.fileMetadataGuid = fileMetadataGuid;
    this.callTime = callTime;
  }
}

@Component({
  selector: 'app-fileuploadhistorygrid',
  templateUrl: './fileuploadhistorygrid.component.html',
  styleUrls: ['./fileuploadhistorygrid.component.css'],
  providers: [FilterService, VirtualScrollService, ToolbarService, ExcelExportService, PdfExportService, NgbTooltipModule, NgbTooltipConfig],
  encapsulation: ViewEncapsulation.Emulated
})
export class FileUploadHistoryGridComponent implements OnChanges, OnInit, AfterViewInit, AfterContentChecked, OnDestroy {

  @ViewChild('grid', { static: true })
  public grid: GridComponent;

  @ViewChild('tooltipObj', { static: true }) tooltipObj: TooltipComponent;

  @ViewChild('copiedTextDialog', { static: true })
  public copiedTextDialog: DialogComponent;

  @ViewChild('tooltip', { static: false })
  public tooltipControl: TooltipComponent;

  public toolbar: ToolbarItems[] = [];
  public data: Object[];
  public dateFormat: Object;
  public customerId: string;
  public fileCount: string;
  error: string;
  filterSettings: FilterSettingsModel;
  pageOptions: Object;
  gridComplete = false;
  lastCallTimes: LastCallTime[] = [];
  settings: IServerSettings;
  copiedToClipboard = '';

  tooltipContent: HTMLElement = document.createElement('div');

  @Input() gridData: string;
  @Input() appDefaults: any;
  @Output() messageEvent = new EventEmitter<string>();

  initial = true;
  scrollSettings: { width: string; height: number; enableColumnScrolling: boolean; enableRowScrolling: boolean; };

  tooltipCol: Tooltip = new Tooltip({
    content: this.tooltipContent,
    cssClass: 'customtooltip',
    enableHtmlParse: false
  });
  sub: Subscription;

  constructor (private router: Router, private fileUploadService: FileUploadService, private storageManagerService: StorageManagerService, private cdref: ChangeDetectorRef, private settingsService: SettingsService, private toastr: ToastrService, tooltipConfig: NgbTooltipConfig) {
    this.settings = this.settingsService.getSettings();
    tooltipConfig.placement = 'bottom-left';
    tooltipConfig.autoClose = true;   
  }

  ngAfterViewInit(): void {

  }

  async copyToClipboard(args, data, tt) {

    this.copiedToClipboard = data;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(data)
        .then(
          () => this.openTooltip(tt, `${data} - Copied to Clipboard`)
        );
    }
  }

  openTooltip(tooltip, contents: string) {

    tooltip.close();
    tooltip.open({ contents });
  }

  closeTooltip(tooltip) {
    tooltip.close();
  }

 async keydownEnter(e, data) {
   const type = e.type;

   this.copiedToClipboard = data;

   if (type === 'keydown' && (e.which === 13 || e.keyCode === 13)) {

     if (navigator.clipboard) {
       navigator.clipboard.writeText(data)
         .then(
           () => e.target.closest('.e-templatecell').focus()
         );
     }
    }
  }

  tooltipContents(data) {

   return data;
  }

  showSFToolTip(args, data) {

    let customContent = '';

    let tooltipId = args.target.closest('.e-tooltip').id;

    this.tooltipControl = (document.getElementById(tooltipId) as any).ej2_instances[0];

    if (this.tooltipControl) {

      this.tooltipControl.width = 'Auto';
      this.tooltipControl.tipPointerPosition = 'Auto';

      if (data.toLowerCase() === 'copied') {

        customContent = `<span class='tooltip-copy-span'>Copy to Clipboard: <span class='primary bolder'>${ this.copiedToClipboard }</span> - </span><span class='text-success tooltip-copy-span bolder'>Copied!</span>`;
        this.tooltipControl.content = customContent;
      } else {
        this.tooltipControl.width = '425px';
        customContent = `<span class='tooltip-copy-span'>Copy to Clipboard: </span><span class='primary tooltip-copy-span bolder'>${ data }</span>`;
        this.tooltipControl.content = customContent;
      }

      if (this.tooltipControl) {
        this.tooltipControl.open(args.target);
      }
    }
  }

  hideSFToolTip(args) {

    this.tooltipControl = (args.target as any).parentElement?.ej2_instances[0];

    if (this.tooltipControl) {
      this.tooltipControl.content = '';
      this.tooltipControl.close();
    }
  }

  tooltipValue(args) {
    // here you can get the row data of the target cell
    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {
      const rowInfo = this.grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltipObj.content = rowData[(rowInfo.column as any).field];
      this.tooltipObj.width = `${ args.target.scrollWidth }px`;
    }
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    const gridData: SimpleChange = changes.gridData;
    if (gridData && gridData.currentValue) {
      this.data = DataUtil.parse.parseJson(gridData.currentValue);
    } else {
      this.error = 'External error';
    }
  }

  ngOnInit(): void {
    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');

    if (currentCustomerStr) {
      const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
      if (currentCustomer) {
        this.customerId = currentCustomer.customerId;
      }
    }
    this.dateFormat = { type: 'dateTime', format: 'MM/dd/yyyy hh:mm a' };

    this.filterSettings = {
      type: 'Menu',
      operators: {
        stringOperator: [
          { value: 'contains', text: 'contains' },
          { value: 'startsWith', text: 'starts with' },
          { value: 'endsWith', text: 'ends with' },
          { value: 'equal', text: 'equal' }
        ],
        dateOperator: [
          { value: 'equal', text: 'equal' }
        ],
      }
    };

    if (this.appDefaults) {
      this.pageOptions = { pageSize: this.appDefaults.defaultPageSize, pageCount: this.appDefaults.pageCount, pageSizes: this.appDefaults.pageSizes };
    }
  }

  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'eGrid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  recordDoubleClickRow(args) { }

  downloadLog(fileMetadataGuid, importId, reportFormat) {
    if (fileMetadataGuid) {

      let fileName = `${ importId }__ImportLog`;
      if (reportFormat === 'Excel') {
        fileName += '.xlsx';
      } else {
        fileName += '.csv';
      }

      this.fileUploadService.getLogDataFile(fileMetadataGuid, this.customerId, reportFormat, fileName).subscribe(response => {
        //  var fileUrl = URL.createObjectURL(response);

        // todo: this pop-up logic works, however it can possibly be simplified - some commented code below creates a link in non-IE browser as well

        // IE
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(response, fileName);
        } else {
          // non-IE
          const URL = window.URL || (<any>window).webkitURL;
          const downloadUrl = URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = fileName;
          link.click();
          //    window.location.href = fileUrl;
        }
      });
    }
  }
  complete(args: any) {
    switch (args.requestType) {
      case 'filterafteropen':

        if (args.columnType === 'date') {
          args.filterModel.dlgDiv.querySelector(
            '.e-datepicker'
          ).ej2_instances[0].format = 'MM/dd/y';
        }
        break;
      case 'filtering':

        if (this.grid && this.grid.columns && this.grid.columns.length > 0) {
          const pageCountMsg = document.getElementsByClassName('e-pagecountmsg')[0];

          if (pageCountMsg) {
            const pageItemCounter = (pageCountMsg as any).innerText;

            this.fileCount = pageItemCounter.substr(pageItemCounter.indexOf('(') + 1, pageItemCounter.indexOf(' item') - 1);
          } else {
            this.fileCount = '0';
          }
          this.messageEvent.emit(this.fileCount);
        }
        break;
    }
  }


  // commented out the functionality because the "copy" functionality was added with its tooltips
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'importId') {
      // const tooltip: Tooltip = new Tooltip({
      //  // position: 'TopLeft',
      //   content: args.data['fileMetadataGuid'].toString()
      // }, args.cell as HTMLTableCellElement);
    }
  }

  getFileOutcome(fileOutcomeCode, fileMetadataGuid, createDatetime) {
    if (fileOutcomeCode) {
      return;
    }

    if (!fileMetadataGuid) {
      return;
    }

    if (!createDatetime) {
      return;
    }

    const createDate = Date.parse(createDatetime);

    const existedSeconds = (Date.now().valueOf() - createDate.valueOf()) / 1000;
    const existedMinutes = existedSeconds / 60;

    if (existedMinutes > this.settings.IngestionStatusTimeout) {
      return;
    }

    let lastCallTime = this.lastCallTimes.find(x => x.fileMetadataGuid === fileMetadataGuid);

    if (lastCallTime) {
      const start = (lastCallTime.callTime as any);
      const end = Date.now();

      const seconds = Math.abs(end.valueOf() - start.valueOf()) / 1000;

      if (seconds < this.settings.IngestionStatusPollInterval) {
        return;
      }

      lastCallTime.callTime = Date.now();
    } else {
      lastCallTime = new LastCallTime(fileMetadataGuid, Date.now());
      this.lastCallTimes.push(lastCallTime);
    }

    this.fileUploadService.getFileOutcome(fileMetadataGuid).subscribe(x => {
      if (!x || !x?.fileOutcomeCode) {
        return;
      }

      const dataItem = this.data.find(f => (f as any).fileMetadataGuid === fileMetadataGuid);

      if (!dataItem) {
        return;
      }

      const rowItem = dataItem as any;
      rowItem.fileOutcomeCode = x.fileOutcomeCode;
      rowItem.fileOutcome = x.fileOutcomeDesc;
      rowItem.totalRecords = x.totalSuccessRecords + x.totalFailedRecords;
      rowItem.totalSuccessRecords = x.totalSuccessRecords;
      rowItem.totalExceptionRecords = x.totalFailedRecords;
      rowItem.createDatetime = x.updateDateTime;

      this.grid.refresh();
    });
  }

  getCSSClasses(fileOutcomeCode) {
    let cssClasses;

    if (!this.error && fileOutcomeCode !== undefined) {
      cssClasses = {
        'small-loading': +fileOutcomeCode === 0,
        'success': +fileOutcomeCode === 1,
        'status-warning': +fileOutcomeCode === 3,
        'status-fail': +fileOutcomeCode === 4 || +fileOutcomeCode === 2
      };
    }
    return cssClasses;
  }
}

